module.exports = __webpack_public_path__ + "static/media/cap1-05-mob.a036ae9c.png";